import { createASpoolActions, createASpoolType } from './createASpoolType';

const createASpoolReducer = (state: createASpoolType, action: createASpoolActions) => {
    switch (action.type) {
        case 'SET_STEP_COMPLETED':
            return {
                ...state,
                steps: state.steps.map((step, index) => {
                    return action.payload.stepNumber === index + 1
                        ? { ...step, completed: action.payload.status }
                        : step;
                }),
            };
        case 'SET_CURRENT_STEP':
            return {
                ...state,
                currentStep: action.payload,
            };
        case 'SET_SELECTED_ASSET':
            return {
                ...state,
                selectedAsset: action.payload,
                selectedStrategies: [],
            };
        case 'SET_SELECTED_RISK_MODEL':
            return {
                ...state,
                selectedRiskModel: action.payload,
            };

        case 'ADD_STRATEGY':
            return {
                ...state,
                selectedStrategies: [...state.selectedStrategies, action.payload],
            };
        case 'REMOVE_STRATEGY':
            return {
                ...state,
                selectedStrategies: state.selectedStrategies.filter(
                    (strategy) => strategy !== action.payload
                ),
            };
        case 'SET_RISK_TOLERANCE':
            return {
                ...state,
                riskTolerance: action.payload,
            };
        case 'SET_ALLOCATIONS':
            return {
                ...state,
                allocations: action.payload,
            };
        case 'SET_BASE_APY':
            return {
                ...state,
                baseApy: action.payload,
            };
        case 'SET_SPOOL_NAME':
            return {
                ...state,
                spoolName: action.payload,
            };
        case 'SET_SPOOL_FEE':
            return {
                ...state,
                spoolFee: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default createASpoolReducer;
